
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './styles/touch-targets.css'
import { AppCrashBoundary } from './components/AppCrashBoundary'
import { developmentDetector } from './utils/developmentModeDetector'
import { initializePerformanceOptimizations } from './utils/performanceOptimizations'

// Nuclear Reset - Conditional initialization based on environment
const config = developmentDetector.getConfig();

const initializeProductionSystems = async () => {
  if (config.isDevelopment) {
    // Silent development mode - no logging
    return;
  }

  // Production initialization without logging
  try {
    const { healthChecker } = await import('./utils/healthChecker');
    const { externalResourceManager } = await import('./utils/externalResourceManager');
    
    // Progressive resource loading (production only)
    setTimeout(() => {
      externalResourceManager.loadProgressively().catch(() => {
        // Silent failure handling
      });
    }, 1000);

    // Health monitoring (production only)
    setTimeout(() => {
      healthChecker.startPeriodicHealthChecks(15 * 60 * 1000);
    }, 10000);
    
  } catch (error) {
    // Silent error handling
  }
};

// Initialize systems based on environment
initializeProductionSystems();

// Initialize performance optimizations (respects development mode)
if (!config.isDevelopment) {
  const run = () => initializePerformanceOptimizations();
  // Defer to idle to keep hero under 200ms
  if ('requestIdleCallback' in window) {
    requestIdleCallback(run);

  } else {
    setTimeout(run, 200);
  }
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AppCrashBoundary>
      <App />
    </AppCrashBoundary>
  </StrictMode>
);
